import { useContext, useLayoutEffect } from 'react';
import { ErrorView } from '../Common/Error';
import { useTranslate } from '@/hooks/useTranslate';
import { useReportPaymentMethodUnavailable } from '@/context/PaymentMethodAvailabilityContext';
import { CheckoutContext } from '@/context/CheckoutContext';
import { TemplateType } from '@/types/boot';

interface PaymentMethodNotSupportedProps {
  /** Express wallet row — collapse silently; inline error is APM-only. */
  isExpress?: boolean;
}

const PaymentMethodNotSupported = ({ isExpress = false }: PaymentMethodNotSupportedProps) => {
  const { t } = useTranslate();
  const setUnavailable = useReportPaymentMethodUnavailable();
  const { template } = useContext(CheckoutContext);

  useLayoutEffect(() => {
    if (isExpress || !setUnavailable) return;
    setUnavailable(true);
    return () => setUnavailable(false);
  }, [isExpress, setUnavailable]);

  if (isExpress) {
    return null;
  }

  return (
    <ErrorView
      message={
        template.type === TemplateType.SINGLE_PAYMENT_METHOD
          ? t('appchargeErrors.paymentMethodNotAvailableGoBackAndTrySelectingAnotherMethod')
          : t('appchargeErrors.paymentMethodNotAvailableChooseAnotherMethod')
      }
    />
  );
};

export default PaymentMethodNotSupported;
